export default [
  {
    header: 'PostOP',
    icon: 'GridIcon',
    route: 'post-op',
    title: 'PostOP'
  },
]
